import { array, object, string, ValidationError } from 'yup'
import { transformStringDateFormatToDate } from '@/shared/lib/helpers/transformStringDateFormatToDate.js'

export const ProfUnionsValidationSchema = object().shape({
	bin: string().when('typeCode', {
		is: (typeCode) => typeCode !== 'primary',
		then: string()
			.required({ key: 'required' })
			.matches(/^[0-9]+$/, 'contracts_tab.not_correct_bin')
			.min(12, { key: 'min_12_length' }),
		otherwise: string().nullable(),
	}),
	unionName: string().required('required'),
	dateCreate: transformStringDateFormatToDate().required({ key: 'required' }),
	typeCode: string().required('required'),
	chiefIin: string()
		.required({ key: 'required' })
		.matches(/^[0-9]+$/, { key: 'not_correct_iin' })
		.min(12, { key: 'validation.min_length', value: 12 })
		.max(12, { key: 'validation.max_length', value: 12 }),
	chiefFio: string().required('required'),
	industryCode: string().when('typeCode', {
		is: (typeCode) => typeCode === 'industry',
		then: string().required('required'),
		otherwise: string().nullable(),
	}),
	parents: array()
		.of(
			object().shape({
				parentBin: string().when('typeCode', {
					is: (typeCode) => typeCode !== 'industry',
					then: string().required('required'),
					otherwise: string().nullable(),
				}),
				parentName: string().when('typeCode', {
					is: (typeCode) => typeCode !== 'industry',
					then: string().required('required'),
					otherwise: string().nullable(),
				}),
			})
		).nullable().defined(),
	employers: array()
		.of(
			object({
				employerBin: string().nullable(),
				employerName: string().nullable(),
			})
		)
		.test(
			'single-or-multiple-validation',
			'required fields missing',
			function (value) {
				if (!value || value.length === 0) return true;

				if (value.length === 1) {
					const first = value[0];
					const isEmpty = !first?.employerName && !first?.employerBin;

					if (isEmpty) return true;
					if (first.employerName && first.employerBin) return true;

					throw this.createError({
						path: `employers[0].employerName`,
						message: 'Заполните оба поля или оставьте оба пустыми',
					});
				}

				const errors = [];
				value.forEach((item, index) => {
					if (!item?.employerName) {
						errors.push(
							this.createError({
								path: `employers[${index}].employerName`,
								message: 'required',
							})
						);
					}
					if (!item?.employerBin) {
						errors.push(
							this.createError({
								path: `employers[${index}].employerBin`,
								message: 'required',
							})
						);
					}
				});

				if (errors.length) throw new ValidationError(errors);
				return true;
			}
		)
		.nullable()
		.defined(),
	managers: array()
		.of(
			object().shape({
				iin: string()
					.required({ key: 'required' })
					.matches(/^[0-9]+$/, { key: 'not_correct_iin' })
					.min(12, { key: 'validation.min_length', value: 12 })
					.max(12, { key: 'validation.max_length', value: 12 }),
				fio: string().required({ key: 'required' }),
				position: string().required({ key: 'required' }),
			})
		).nullable().defined(),
})

export const AddMembersValidationSchema = object().shape({
	members: array()
		.of(
			object().shape({
				iin: string()
					.required({ key: 'required' })
					.matches(/^[0-9]+$/, { key: 'contracts_tab.not_correct_bin' })
					.min(12, { key: 'min_12_length' }),
				fio: string().required({ key: 'required' }),
				dateIn: transformStringDateFormatToDate().required({ key: 'required' }),
			})
		)
		.required(),
})
